import React from 'react'
import { DiscountRow, DiscountRowText } from './CarpayOrderDiscount.style'
import { priceToString } from '@utils/priceToString.utils'
import { formatPriceWithCurrency } from '@utils/formatPriceWithCurrency.utils'
import { useStyletron } from 'parkdepot-shared/theme'
import { useTranslation } from 'react-i18next'

interface CarpayOrderDiscountProps {
    voucherDiscount: number
    whitelistDiscount: number
    fullPrice: number
    currency: string
}

const CarpayOrderDiscount = ({ voucherDiscount, fullPrice, whitelistDiscount, currency }: CarpayOrderDiscountProps) => {
    const [css, theme] = useStyletron()
    const { t } = useTranslation()

    return (
        <>
            {voucherDiscount ? (
                <DiscountRow className={css({ color: `${theme.colors.black} !important` })}>
                    <DiscountRowText>{t('carpay.orderDiscount.subtotal')}</DiscountRowText>
                    <DiscountRowText>
                        {formatPriceWithCurrency(currency).format(priceToString(fullPrice))}
                    </DiscountRowText>
                </DiscountRow>
            ) : null}

            {voucherDiscount ? (
                <DiscountRow>
                    <DiscountRowText>{t('carpay.orderDiscount.voucher')}</DiscountRowText>
                    <DiscountRowText>
                        - {formatPriceWithCurrency(currency).format(priceToString(voucherDiscount))}
                    </DiscountRowText>
                </DiscountRow>
            ) : null}

            {whitelistDiscount ? (
                <DiscountRow>
                    <DiscountRowText>{t('carpay.orderDiscount.whitelist')}</DiscountRowText>
                    <DiscountRowText>
                        - {formatPriceWithCurrency(currency).format(priceToString(whitelistDiscount))}
                    </DiscountRowText>
                </DiscountRow>
            ) : null}
        </>
    )
}

export default CarpayOrderDiscount
